import useTranslator from "../../../hooks/useTranslator";
import "./PropertyPaymentList.css";
import { useContext, useEffect, useState } from "react";
import LandLordContext from "../../../context/landlord/LandLordContext";
import constants from "../../../Utils/constants";
import TenantPaymentList from "../../../components/Landlord/TenantPaymentList";
import "../../../components/Profiles/ProfileTable.css";
import { haveValue } from "../../../helper/common";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Icon,
  PageHeader,
  SkeletonTable,
  Tabs,
  TextField,
} from "../../../components/design";

const PropertyPaymentList = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const [tab, setTab] = useState("waiting");
  const [loading, setLoading] = useState(true);
  const queryParam = new URLSearchParams(window.location.search);
  const isConfirmation = queryParam.get("confirmation");
  const assigned_prop_id = queryParam.get("assigned_prop");
  const landLordContext = useContext(LandLordContext);
  const { fetchAssignedProperties, fetchAssignedDetails } = landLordContext;
  const landlordId = localStorage.getItem("saveduserid");
  const [paymentSet, setPaymentSet] = useState([]);
  const [paymentNotSet, setPaymentNotSet] = useState([]);
  const [defaultPaymentSet, setDefaultPaymentSet] = useState([]);
  const [defaultPaymentNotSet, setDefaultPaymentNotSet] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [showNoti, setShowNoti] = useState(false);
  const [recentAwarded, setRecentAwarded] = useState({});

  useEffect(() => {
    fetchAssignedProperties(landlordId)
      .then((res) => {
        const temp_not = [];
        const temp_yes = [];
        res.result.map((assigned) => {
          if (assigned.status == constants.TENANT_PENDING) {
            temp_not.push(assigned);
          } else if (assigned.status == constants.AWARDED) {
            temp_yes.push(assigned);
          }
        });
        setPaymentNotSet(temp_not);
        setPaymentSet(temp_yes);
        setDefaultPaymentNotSet(temp_not);
        setDefaultPaymentSet(temp_yes);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (
    haveValue(isConfirmation) &&
    haveValue(assigned_prop_id) &&
    isConfirmation
  ) {
    navigate(`/${workspaceId}/payment/property/list`);
    fetchAssignedDetails(assigned_prop_id)
      .then((res) => {
        const data = res.result;
        setRecentAwarded(data);
        setShowNoti(true);
        setTimeout(() => {
          setShowNoti(false);
        }, 10000);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // tenant first name, last name, full name or property address
  const matches = (obj, value) => {
    if (!obj?.tenant_id?.fname || !obj?.tenant_id?.lname) return false;
    const { fname, lname } = obj.tenant_id;
    const q = value.toLowerCase();
    const address = `${obj?.property_id?.street} ${obj?.property_id?.street_number} ${obj?.property_id?.floor_number} ${obj?.property_id?.flat_number}`;
    return [fname, lname, `${fname} ${lname}`, address].some((text) =>
      text.toLowerCase().includes(q)
    );
  };

  const handleSearchVal = (e) => {
    const value = e.target.value;
    setSearchVal(value);
    if (!haveValue(value)) {
      setPaymentNotSet(defaultPaymentNotSet);
      setPaymentSet(defaultPaymentSet);
    } else {
      setPaymentNotSet(
        defaultPaymentNotSet.filter((obj) => matches(obj, value))
      );
      setPaymentSet(defaultPaymentSet.filter((obj) => matches(obj, value)));
    }
  };

  const rows = tab === "waiting" ? paymentNotSet : paymentSet;
  const rowStatus =
    tab === "waiting" ? constants.TENANT_PENDING : constants.AWARDED;
  const fullName = (person) =>
    `${person?.fname ?? ""} ${person?.lname ?? ""}`.trim();
  const shortAddress = (property) =>
    `${property?.street} - ${property?.street_number}, ${property?.floor_number}-${property?.flat_number}`;

  return (
    <div className="main-page-wrapper mb-4 profileRequestWrapper">
      <PageHeader title={_t("propertiesPayments")} />

      {showNoti && (
        <Card
          className="payments-awarded-note"
          title={_t("tenantReview")}
          description={`${fullName(recentAwarded?.tenant_id)} ${_t(
            "hasNowTwentyFourHourTimeToSetUpThePaymentDetailsFor"
          )} ${shortAddress(recentAwarded?.property_id)}`}
          actions={
            <Button
              variant="ghost"
              size="sm"
              iconOnly
              aria-label={_t("close")}
              iconStart={<Icon name="close" size={16} />}
              onClick={() => setShowNoti(false)}
            />
          }
        />
      )}

      <div className="profile-table-card">
        <div className="profile-table-header">
          <div className="profile-table-toolbar">
            <Tabs
              value={tab}
              onChange={setTab}
              items={[
                {
                  value: "waiting",
                  label: _t("waitingForTenant"),
                  count: loading ? undefined : paymentNotSet.length,
                },
                {
                  value: "inPayment",
                  label: _t("inPayment"),
                  count: loading ? undefined : paymentSet.length,
                },
              ]}
            />
            <TextField
              id="payment-search"
              type="search"
              size="sm"
              className="profile-table-search"
              icon={<Icon name="search" size={18} />}
              onChange={handleSearchVal}
              value={searchVal}
              placeholder={_t("searchPropertyTenant")}
              aria-label={_t("searchPropertyTenant")}
            />
          </div>
        </div>

        {loading ? (
          <SkeletonTable rows={4} columns={3} label={_t("loading")} />
        ) : rows.length === 0 ? (
          <p className="payments-empty">{_t("noDetails")}</p>
        ) : (
          <div className="profile-table-scroll">
            <table className="profile-table payments-table">
              <thead className="hideOnMobile">
                <tr>
                  <th className="tenant-col">{_t("tenant")}</th>
                  <th>{_t("address")}</th>
                  <th>{_t("status")}</th>
                  <th className="action-col"></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((payment) => (
                  <TenantPaymentList
                    key={payment?._id}
                    status={rowStatus}
                    data={payment}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyPaymentList;
